import React from "react";

const DropdownSelectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M6.5 0C10.0899 0 13 2.91015 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5C0 2.91015 2.91015 0 6.5 0ZM3.55529 5.18029C3.3649 5.37067 3.3649 5.67933 3.55529 5.86971L6.15529 8.46971C6.34567 8.66009 6.65433 8.66009 6.84471 8.46971L9.44471 5.86971C9.6351 5.67933 9.6351 5.37067 9.44471 5.18029C9.25433 4.9899 8.94567 4.9899 8.75529 5.18029L6.5 7.43557L4.24471 5.18029C4.05433 4.9899 3.74567 4.9899 3.55529 5.18029Z"
        fill="#8A8886"
      />
    </svg>
  );
};

export default DropdownSelectIcon;
